import React from "react"

const ButtonPagination = (props) => {

  const {
    children,
    active = false,
    className,
    disabled,
    entityMainColor,
    onClickFunction,
    secondaryColor
  } = props

  const getDefaultStyle = () => {
    const style = {}

    if( entityMainColor && entityMainColor.charAt(0) === '#' && active === true ){
      style.backgroundColor = entityMainColor
    }

    return style
  }

  const styleOver = (e) => {
    if( entityMainColor && entityMainColor.charAt(0) === '#' && active !== true ){
      e.target.style.background = entityMainColor
    }
  }

  const styleOut = (e) => {
    if( entityMainColor && entityMainColor.charAt(0) === '#' && active !== true ){
      e.target.style.background = 'rgb(229 231 235)'
    }
  }

  return (
    <button
      className={className}
      disabled={disabled}
      onClick={onClickFunction}
      onMouseOver={(e) => styleOver(e)}
      onMouseOut={(e) => styleOut(e)}
      style={getDefaultStyle()}
    >
      {children}
    </button>
  )
}

export default ButtonPagination
